<template>
  <div>
    <div class="banner">
      <img src="@/assets/images/banner6.png">
    </div>
    <!-- <div class="news">
      <iframe src="https://www.voatiengviet.com/p/3863.html" class="iframe-1" scrolling="no"></iframe>
    </div> -->
  </div>
</template>
<script>
export default {
  name: 'RightNews'
}
</script>
<style lang="scss" scoped>
.news {
  overflow: hidden;

  .iframe-1 {
    border: 0;
    height: 1510px;
    margin-top: -80px;
    pointer-events: none;
    overflow: hidden;
  }
}

@media screen and (max-width: 600px) {
  .news {
    margin-top: 15px;
    .iframe-1 {
      //margin-top: -380px;
      height: 1350px;
    }
  }
}
</style>
